import { Component, NgZone } from "@angular/core";
import { NavController, NavParams, App, ModalController } from "ionic-angular";

import { APIServiceProvider } from "./../../../common/services/api.service";
import { HelperServiceProvider } from "./../../../common/services/helper.service";
import { TabInventoryDetails } from "../inventorydetailstabs/tabs-inventorydetails";
import { InventoryDetailsService } from "../inventorydetails.service";
import { StockReturnModalPage } from "../../../modals/stockreturn/stockreturn.modal";
import { NotifyService } from "../../../services/notify.service";
@Component({
	selector: "page-inventoryall",
	templateUrl: "inventoryall.html"
})
export class InventoryAllPage {
	constructor(
		public navCtrl: NavController,
		public helperService: HelperServiceProvider,
		public navParams: NavParams,
		public zone: NgZone,
		public modalController: ModalController,
		private notifyService: NotifyService,
		public apiHelper: APIServiceProvider,
		private inventoryDetailsService: InventoryDetailsService,
		private app: App
	) {}

	public inventories: any = [];
	public pagination: any = {};

	public postParams: any = {};
	public searchText: any = "";

	public inventoryAllUrl =
		"inventory/get-inventory?manager_id=" +
		localStorage.getItem("manager_user_id");

	ionViewDidLoad() {
		this.notifyService.inventoryUpdated.subscribe(() => {
			this.getAllInventory(this.inventoryAllUrl);
		});

		this.getAllInventory(this.inventoryAllUrl);
	}

	stockReturn(inventory) {
		let modalObject = this.modalController.create(StockReturnModalPage, {
			inventory: inventory
		});
		modalObject.present();
	}

	getAllInventory(url, refresh?) {
		this.apiHelper.get(url).subscribe(
			response => {
				this.inventories = response["data"]["data"];
				this.pagination = response["data"];
				if (refresh) {
					refresh.complete();
				}
			},
			error => {}
		);
	}

	doRefresh(refresher) {
		this.getAllInventory(this.inventoryAllUrl, refresher);
	}

	doInfiniteScroll(event) {
		if (
			!this.pagination.next_page_url ||
			this.pagination.next_page_url === "" ||
			this.pagination.next_page_url === null ||
			this.pagination.next_page_url === "null"
		) {
			event.complete();
			return;
		} else {
			this.apiHelper
				.get(
					null,
					null,
					this.pagination["next_page_url"] +
						"&manager_id=" +
						localStorage.getItem("manager_user_id") +
						"&search=" +
						this.searchText
				)
				.subscribe(
					response => {
						this.inventories = this.inventories.concat(
							response["data"]["data"]
						);
						this.pagination = response["data"];
						event.complete();
					},
					error => {}
				);
			return;
		}
	}

	inventoryDetails(inventory) {
		this.inventoryDetailsService.inventory = inventory;
		this.app.getRootNav().push(TabInventoryDetails);
	}

	search(text) {
		this.getAllInventory(
			this.inventoryAllUrl + "&search=" + this.searchText
		);
	}

	clearSearch(text) {
		this.searchText = "";

		this.getAllInventory(
			this.inventoryAllUrl + "&search=" + this.searchText
		);
	}
}



// WEBPACK FOOTER //
// ./src/pages/inventory/inventoryall/inventoryall.ts